export default __webpack_public_path__ + "static/media/roselyn.2f8d69eb.png";